export default __webpack_public_path__ + "static/media/product_test_discovery_ric.70900390.jpg";